import React, { useEffect, useRef, useState } from 'react';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from '../../../common/table/agGrid/AgGridCommon';
import { common } from 'utils/agGrid/options';
import { createLoadingSelector } from 'erisxkit/client';
import { useAppSelector } from 'hooks/useAppSelector';
import { ABOUT } from 'constants/actionTypes';
interface SystemApplicationsGridProps {
  data: any;
  colDefs: any;
}

export const gridName = 'system-applications';

const SystemApplicationsGrid: React.FC<SystemApplicationsGridProps> = ({
  data,
  colDefs,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState(null);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const loading = useAppSelector((state) =>
    createLoadingSelector([ABOUT])(state),
  );
  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName,
  });

  useEffect(() => {
    setRowData(data);
    if (!initialGridSettings?.columnSizing) {
      gridRef.current?.api?.sizeColumnsToFit();
    }
  }, [data, initialGridSettings?.columnSizing]);

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <AgGridReact
          loading={loading}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          gridOptions={common}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
        />
      )}
    </div>
  );
};

export default SystemApplicationsGrid;
